

<template>
  <div class="r">
    <router-link
      :to="{ name: 'scenarios-upload'}"
      class="no-results-found d-flex flex-column justify-content-center align-items-center"
    >
      <h2 class="text-center">You haven't contributed any of this content yet!</h2>
      <img src="../assets/no-contributed.png" class="my-4" alt="no results" />
      <h5 class="text-itallic">Click here to start uploading.</h5>
    </router-link>
  </div>
</template>
<script>
export default {
  methods: {},
  beforeMount() {}
};
</script>

<style scoped>
.no-results-found {
  opacity: 0.5;
}

.no-results-found h5 {
  max-width: 40%;
  text-align: center;
  font-style: italic;
}

.no-results-found img {
  width: 20%;
  height: auto;
}
</style>
